import React, { useRef } from "react";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { BackBarButtonMini } from "../../common/backBarButton";

// ============================================================================
// MAIN COMPONENT
// ============================================================================

var SubscriptionsContent = function (props) {
  var data = props.data;
  var { ref, focusKey } = useFocusable();
  var innerRef = useRef(null);

  return (
    <div className="legacy-profile-list-shell">
      <div className="legacy-profile-list-inner">
        <FocusContext.Provider value={focusKey}>
          <div className="legacy-profile-list-scroll legacy-profile-list-scroll-table" ref={ref}>
            <div className="legacy-profile-list-header">
              <div className="legacy-profile-list-header-cell">
                <BackBarButtonMini />
                <h4 className="legacy-profile-list-title">اشتراک های من</h4>
              </div>
            </div>

            <div ref={innerRef}>
              {data && data.length > 0 ? (
                <div className="legacy-profile-table-container">
                  <table className="legacy-profile-table">
                    <thead>
                      <tr className="legacy-profile-table-row">
                        <th>ردیف</th>
                        <th>نوع</th>
                        <th>تاریخ</th>
                        <th>مبلغ</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map(function (item, index) {
                        var orderType = item.orderType;
                        var createdAt = item.createdAt;
                        var amount = item.amount;
                        var subscriptionInfo = item.subscriptionInfo;
                        var _id = item._id;

                        return (
                          <tr className="legacy-profile-table-row" key={_id}>
                            <td>{index + 1}</td>
                            <td>
                              {orderType === "subscription"
                                ? "اشتراک"
                                : "سینما آنلاین"}
                            </td>
                            <td>
                              {new Date(createdAt).toLocaleString("fa")}
                            </td>
                            <td>
                              {amount ? amount.toLocaleString() : "-"}
                              <span className="legacy-profile-muted-text">تومان</span>
                            </td>
                            <td>
                              {orderType === "subscription" &&
                                subscriptionInfo &&
                                subscriptionInfo.purchasedSubscription &&
                                subscriptionInfo.purchasedSubscription.name && (
                                  <span>
                                    {subscriptionInfo.purchasedSubscription.name}
                                    {" - "}
                                    {subscriptionInfo.purchasedSubscription.lifeTimeDays}
                                    <span className="legacy-profile-muted-text">روزه</span>
                                  </span>
                                )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="legacy-profile-list-empty">
                  <p>موردی یافت نشد</p>
                </div>
              )}
            </div>
          </div>
        </FocusContext.Provider>
      </div>
    </div>
  );
};

export default SubscriptionsContent;
